module.exports = __webpack_public_path__ + "static/stories-c9d265241b28b3d04f6cb05cdc2d175f.png";